/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 30,
  image: "default-changelog-v2.png",
  title: "New Spheron Platform Features, IPFS Gateways, SDK Improvements, FNS Changes",
  shortDescription: "We have added support for organization deletion. Enhanced the permissions of deployment management. Introduced the dedicated IPFS gateways. Released new versions of Storage and Browser Upload SDKs.",
  description: "We have added support for organization deletion. Enhanced the permissions of deployment management. Introduced the dedicated IPFS gateways. Released new versions of Storage and Browser Upload SDKs.",
  date: "May 19th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Storage", "SDK", "Browser-Upload", "FNS"]
};
export const content = `
## [Spheron Platform](https://app.spheron.network/) Updates
- **Organization Deletion Support**: Introducing organization deletion support, allowing effortless removal of entire organizations from the platform, facilitating restructuring or decluttering.

## Enhanced Permissions for Deployment Management:

- Owners and admins authorize deployments, ensuring authorized personnel oversee the process.
- Owners and admins can stop any deployments, maintaining centralized and secure management.
- Members can stop their own deployments, increasing accountability and workflow efficiency.

## Support for updating cluster instance tag:

- New feature enables seamless updating of Docker image tags, ensuring optimal performance, security, and compatibility.

## Fixes & Improvements:

- **Docker Image OS Check**: Added a check to deploy only Linux amd64-compatible images, reducing compatibility issues.
- Significant UX improvements and bug fixes for deployment and billing pages, enhancing the user experience.

## API Changes:

- Updated response of \`GET: /v1/organization/{organizationId}/subscription-usage/specialization/{specialization}\` endpoint.
- Removed deprecated properties \`usedStorageFileCoin\` and \`storageFileCoinLimit\`.
- Added new properties \`usedParallelUploads\` and \`parallelUploadsLimit\`.

## New Release of [Storage SDK](https://www.npmjs.com/package/@spheron/storage) and [Browser Upload](https://www.npmjs.com/package/@spheron/browser-upload) Package:

- Significant improvements, particularly in error handling, providing more detailed information for effective troubleshooting.
- Revamped usage interface of the Storage SDK for a more user-friendly experience.

## [FNS](https://fns.site/) Changes:

New version of the FNS app includes:

- **Record Addition/Updation in FNS Domain**: Users can add or update records for their FNS domains, including Address (BTC, ETH, etc.), Social (Discord, Twitter, etc.), and text records in their Filecoin domain.
- **Extend Validity of FNS Domains**: Users can extend the validity of their domains directly from the app when connected with the same wallet.

## IPFS Gateway:

- Introducing new dedicated IPFS Gateways for optimized access to pinned content, offering faster speeds, higher rate limits, and improved reliability. Ensures a seamless experience when accessing and serving content on the IPFS network.
- Checkout the [DOCS](https://docs.spheron.network/gateways/) for more details.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
